import { Field } from "@headlessui/react";
import { AnimatePresence, motion } from "motion/react";

import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import { IconMagnifyingGlass, IconX } from "@/components/icons";

import { ROUTES } from "@/config/routes";

const HeaderSearchInput = ({ isSearchPage }: { isSearchPage: boolean }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();

  const search = params.get("search");

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setParams(`search=${event.target.value}`);
  };

  const openSearch = () => {
    if (isSearchPage) {
      navigate(ROUTES.MAIN.MAIN);
    } else {
      navigate(ROUTES.SEARCH);
    }
  };
  return (
    <>
      <li className={"relative flex items-center"}>
        <AnimatePresence>
          {isSearchPage && (
            <motion.div
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 100, opacity: 0 }}
              className="absolute right-0 z-[1] max-sm:left-0"
            >
              <Field className="relative z-10">
                <IconMagnifyingGlass className="absolute left-2 top-2 size-6 stroke-white" />
                <input
                  onChange={onChange}
                  value={search ?? ""}
                  className="block w-full min-w-full border-b bg-transparent py-2 pl-12 outline-none placeholder:text-secondary-60 sm:w-[40vw]"
                  placeholder="Название фильма, сериала или создателя "
                  autoFocus
                />
              </Field>
            </motion.div>
          )}
        </AnimatePresence>
        <button
          type={"button"}
          title={t("search")}
          onClick={openSearch}
          className={"relative z-[10] rounded-full p-2 max-sm:hidden"}
        >
          {isSearchPage ? (
            <IconX className="size-6 stroke-on-primary" />
          ) : (
            <IconMagnifyingGlass className={"size-6 stroke-white"} />
          )}
        </button>
      </li>
    </>
  );
};

export default HeaderSearchInput;
